import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import Slider from '../slider/slider.component';
import { TooltipsService } from '../../services/tooltips.service';
import './product-offering-slider.component.scss';
import * as $ from 'jquery';
import * as _ from 'lodash';
var ProductOfferingSlider = /** @class */ (function (_super) {
    tslib_1.__extends(ProductOfferingSlider, _super);
    function ProductOfferingSlider(element) {
        return _super.call(this, element) || this;
    }
    ProductOfferingSlider.prototype.init = function () {
        this.productContainer = $('.product-card-wrapper');
        this.endpoint = this.element.getAttribute('data-endpoint');
        this.producttype = $("div.component.product-offering-slider").attr('data-producttype');
        if (this.producttype) {
            this.producttype = this.producttype.toLowerCase();
        }
        this.getProducts();
    };
    ProductOfferingSlider.prototype.bindEvents = function () {
        var _this = this;
        window.addEventListener('resize', this.debounce(function () {
            _this.normalizeCardHeight();
        }, 50, false));
    };
    ProductOfferingSlider.prototype.animate = function () {
    };
    ProductOfferingSlider.prototype.getProducts = function () {
        var _this = this;
        var parseData = sliderJsonData;
        this.filterJson = parseData.filters;
        this.productJson = parseData.products;
        this.comparable = _.some(this.productJson, function (product) {
            return product.comparable;
        });
        var docfragment = document.createDocumentFragment();
        this.productJson.forEach(function (card) {
            docfragment.appendChild(_this.renderProduct(card));
        });
        this.productContainer[0].appendChild(docfragment);
        TooltipsService.initTooltips();
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        setTimeout(function () {
            _this.initSlider();
            _this.normalizeCardHeight();
        }, 500);
    };
    ProductOfferingSlider.prototype.initSlider = function () {
        this.sliderConfig = {
            slidesPerView: 2,
            spaceBetween: 35,
            initialSlide: 0,
            breakpoints: {
                1200: {
                    initialSlide: 0,
                    slidesPerView: 1.8,
                    spaceBetween: 35,
                },
                768: {
                    initialSlide: 0,
                    slidesPerView: 1.5,
                    spaceBetween: 20,
                },
                576: {
                    initialSlide: 0,
                    slidesPerView: 1.2,
                    spaceBetween: 15,
                }
            },
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            }
        };
        Slider.init(this.sliderContainer, this.sliderConfig);
    };
    ProductOfferingSlider.prototype.normalizeCardHeight = function () {
        if ($(window).width() < 951) {
            $('.product-card__content').css('min-height', "initial");
            $('.product-card__content > p').css('min-height', "initial");
        }
        else {
            var highestContent_1 = 0;
            $('.product-card__content').each(function (index, el) {
                var contentHeight = $(el).outerHeight();
                if (highestContent_1 < contentHeight) {
                    highestContent_1 = contentHeight;
                }
            });
            $('.product-card__content').css('min-height', highestContent_1 + "px");
            var highestParagragh_1 = 0;
            $('.product-card__content > p').each(function (index, el) {
                var paragraphHeight = $(el).height();
                if (highestParagragh_1 < paragraphHeight) {
                    highestParagragh_1 = paragraphHeight;
                }
            });
            $('.product-card__content > p').css('min-height', highestParagragh_1 + "px");
            var highestTerms_1 = 0;
            $('.product-card__terms').each(function (index, el) {
                var termHeight = $(el).height();
                if (highestTerms_1 < termHeight) {
                    highestTerms_1 = termHeight;
                }
            });
            $('.product-card__terms').css('min-height', highestTerms_1 + "px");
        }
    };
    ProductOfferingSlider.prototype.renderProduct = function (input) {
        var _this = this;
        var productPrices = "";
        var productTags = "";
        var productButtons = "";
        var productTerms = "";
        var termCount = 0;
        input.pricing.forEach(function (price) {
            if (price.terms) {
                termCount++;
                var asterix = '';
                for (var index = 0; index < termCount; index++) {
                    asterix += '*';
                }
                productTerms += "\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<span class=\"title title--asterisk\">" + asterix + "</span>\n\t\t\t\t\t\t<span>" + price.terms + "</span>\n\t\t\t\t\t</div>\n\t\t\t\t";
            }
            productPrices += _this.renderProductPrice(price, termCount);
        });
        input.tags.forEach(function (tag) {
            productTags += " " + tag.replace(/ /g, "-");
        });
        var btnCount = 0;
        input.buttons.forEach(function (btn) {
            productButtons += _this.renderButtons(btn, btnCount, input);
            btnCount++;
        });
        productTerms = "\n\t\t\t<div class=\"product-card__terms\">\n\n\t\t\t\t" + productTerms + "\n\n\t\t\t</div>";
        var output = "";
        output += "<div class=\"product-card product-card__image swiper-slide " + productTags.toLowerCase() + "\" data-id=\"" + input.id + "\">";
        switch (input.title.toLowerCase()) {
            case "student loan": {
                if (input.onPromotion) {
                    output += '<div class="product-card__feature-badge feature-badge">Increase Limit</div>';
                }
                break;
            }
            case "overdraft": {
                if (input.onPromotion) {
                    output += '<div class="product-card__feature-badge feature-badge">Increase Limit</div>';
                }
                break;
            }
            case "revolving loan": {
                if (input.onPromotion) {
                    output += '<div class="product-card__feature-badge feature-badge">Increase Limit</div>';
                }
                break;
            }
            default: {
                if (input.onPromotion) {
                    output += '<div class="product-card__feature-badge feature-badge">' + input.promotionLabel + '</div>';
                }
            }
        }
        if (input.cardImage) {
            output += '<img class="product-card__image--card" src="' + input.cardImage + '">';
        }
        output += "\n\t\t<div class=\"product-card__outer\">\n\t\t\t<div class=\"product-card__inner\" data-trackingregion=\"product offering " + this.producttype + (" > " + input.title.toLowerCase() + "\">\n\t\t\t\t<div class=\"product-card__content\">        \n\t\t\t\t\n\t\t\t\t\t<div class=\"product-card__title title title--module-sub-title\">\n\t\t\t\t\t\t" + input.title + "\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class=\"title-gradient title-gradient--product\"></div>\n\t\t\t\t\t\n\t\t\t\t\t<p>" + input.subTitle + "</p>\n\n\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t" + productPrices + "\n\t\t\t\t\t</div>\t\t\t\t\n\n\t\t\t\t</div>");
        //card buttons
        output += "\n\t\t\t<div class=\"product-card__buttons\">\t\t\n\t\t\n\t\t\t\t<div class=\"row\">\t\t\n\t\t\n\t\t\t\t\t<div class=\"col-12\">\n                    \n\t\t\t\t\t" + productTerms + "\n\t\t\t\t\t\n\t\t\t\t\t<div class=\"float-md-right float-sm-left\">\t\t\t\t\t\n\t\t\n\t\t";
        output += "\n                            <div class=\"" + (this.comparable ? 'product-card__compare-placeholder' : 'product-card__compare-placeholder product-card__compare-placeholder--sml') + "\"></div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t\t" + productButtons + "\n\n\t\t\t\t</div>\n\n\t\t\t</div>";
        //end card buttons
        output += "</div>"; //inner close
        output += "</div>"; //outer close
        output += "</div>"; //main close
        return document.createRange().createContextualFragment(output);
    };
    ProductOfferingSlider.prototype.renderButtons = function (input, index, product) {
        var output = "";
        // Analytics - included the product in the param lis so we can get the prod name
        var productTitle = product.title ? product.title : "<<product name>>";
        var dataIntent = 'Informational';
        if (input.buttonClass) {
            var dataButtonClass = input.buttonClass.toLowerCase();
            if (dataButtonClass === 'eligibility') {
                dataIntent = 'Transactional';
            }
            else if (dataButtonClass === 'callmeback') {
                dataIntent = 'Query';
            }
            else if (dataButtonClass === 'apply') {
                dataIntent = 'Transactional';
            }
            else if (dataButtonClass === 'contactus') {
                dataIntent = 'Query';
            }
            else if (dataButtonClass === 'contact us') {
                dataIntent = 'Query';
            }
            else if (dataButtonClass === 'contact') {
                dataIntent = 'Query';
            }
            else if (dataButtonClass === 'productdetails') {
                dataIntent = 'Informational';
            }
            else if (dataButtonClass === 'compare') {
                dataIntent = 'Comparison;';
            }
        }
        if (input.isModal) {
            output += "\n            <div class=\"" + (index === 0 ? 'product-card__button-wrap' : '') + " col-xs-6 col-sm-6\">\n                <a class=\"button button--main js-apply-now-modal-open\"\n\t\t\t\t\thref=\"#\"\n\t\t\t\t\ttarget=\"\"\n\t\t\t\t\tdata-modal=\"apply-now-modal-" + input.modalId + "\"\n\t\t\t\t\tdata-intent=\"" + dataIntent + "\"\n\t\t\t\t\tdata-scope=\"productOfferingSlider\"\n\t\t\t\t\tdata-id=\"link_content_product offering\"\n\t\t\t\t\tdata-text=\"" + this.producttype + " | " + productTitle + (" | " + input.title + " button click\">\n\n                    " + input.title + "\n\n                </a>\n            </div>\n            ");
        }
        else {
            output += "\n                <div class=\"" + (index === 0 ? 'product-card__button-wrap' : '') + " col-xs-6 col-sm-6\">\n                    <a class=\"button button--main " + (index === 0 ? '' : 'button--white button--border-blue') + "\"\n\t\t\t\t\t\thref=\"" + input.url + "\"\n\t\t\t\t\t\ttarget=\"" + input.target + "\"\n\t\t\t\t\t\tdata-intent=\"" + dataIntent + "\"\n\t\t\t\t\t\tdata-scope=\"productOfferingSlider\"\n\t\t\t\t\t\tdata-id=\"link_content_product offering\"\n\t\t\t\t\t\tdata-text=\"" + this.producttype + " | " + productTitle + (" | " + input.title + " button click\">\n\n                        " + input.title + "\n\n                    </a>\n                </div>\n            ");
        }
        return output;
    };
    ProductOfferingSlider.prototype.renderProductPrice = function (input, termCount) {
        var output = "";
        output += "<div class=\"product-card__price col-6 col-xs-6 col-sm-6\">";
        if (input.symbol && input.symbol.toLowerCase() == 'r') {
            output += "\n\t\t\t\t<span class=\"title title--initial title--currency\">\n\t\t\t\t\t" + input.symbol + "\n\t\t\t\t</span>\n\t\t\t";
        }
        if (input.note) {
            output += "\n\t\t\t\t<span class=\"title title--initial product-card__price__note\">\n\t\t\t\t\t" + input.title + "\n\t\t\t\t</span>\n\t\t\t";
        }
        else {
            output += "\n\t\t\t\t<span class=\"title title--initial title--number\">\n\t\t\t\t\t" + input.title + "\t\n\t\t\t\t</span>\t\t\n\t\t\t";
        }
        // output += `
        // 	<span class="title title--initial title--number">
        // 		${input.title}
        // 	</span>
        // `;
        if (input.symbol && input.symbol.toLowerCase() != 'r') {
            output += "\n\t\t\t\t<span class=\"title title--initial title--currency\">\n\t\t\t\t\t" + input.symbol + "\n\t\t\t\t</span>\n\t\t\t";
        }
        if (input.tooltip) {
            output += "\n\t\t\t\t<span title=\"" + input.tooltip + "\" data-title=\"" + input.tooltip + "\">\n\t\t\t\t\t<i data-component=\"icon\" data-icon=\"icon-tooltip\" class=\"icon \"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n\t\t\t\t\t\t<path fill=\"#0089FF\" fill-rule=\"evenodd\" d=\"M8 16c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm-1-3h2v-2H7v2zm0-4.004h2V3H7v5.996z\"></path>\n\t\t\t\t\t</svg>\n\t\t\t\t\t</i>\n\t\t\t\t</span>\n\t\t\t";
        }
        if (input.terms) {
            var asterix = '';
            for (var index = 0; index < termCount; index++) {
                asterix += '*';
            }
            output += "\n\t\t\t\t<span class=\"title title--initial title--asterisk\">" + asterix + "</span>\n\t\t\t";
        }
        if (input.strike) {
            output += "\n\t\t\t\t<div class=\"title title--initial title--number-strike\">\n\t\t\t\t\t<span class=\"title title--number-striker\"></span>\n\t\t\t";
            if (input.symbol) {
                output += "\n\t\t\t\t\t<span class=\"title title--initial title--currency-sml\">\n\t\t\t\t\t\t" + input.symbol + "\n\t\t\t\t\t</span>\n\t\t\t\t";
            }
            output += "\n\t\t\t\t\t<span class=\"title title--initial title--number-sml\">\n\t\t\t\t\t\t" + input.strike + "\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t";
        }
        output += "\n\t\t\t<div class=\"title title--notes\">\n\t\t\t\t" + input.subTitle + "\n\t\t\t</div>\t\n\t\t";
        output += "</div>"; //main close
        return output;
    };
    ProductOfferingSlider.prototype.debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate)
                    func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow)
                func.apply(context, args);
        };
    };
    ;
    return ProductOfferingSlider;
}(Base));
export { ProductOfferingSlider };



//////////////////
// WEBPACK FOOTER
// ./components/product-offering-slider/product-offering-slider.component.ts
// module id = 452
// module chunks = 0